import { RouteType } from "../../../../types/RouteType";
import { ProjectDetailsStore } from "./ProjectDetails.Store";
import { ServiceStore } from "@intrasync/stores";

const projectDetailsRoute: RouteType = {
  name: "Project Details",
  path: "/crm/accounts/:accountId/project-details/:projectId",
  layout: "/app",
  viewportCard: {
    header: {
      component: () => import("./ProjectDetails.Header"),
      title: "Project Details",
      enableBackButton: true,
    },
    body: {
      component: () => import("./ProjectDetails.Body"),
      grayBackground: true,
    },
  },
  group: 'CRM',
  requiresAuth: true,
  requiresPermission: false,
  dialogs: [
    {
      name: "Purchase Order Details",
      component: () => import("./ProjectDetailsDialogs/PurchaseOrderDetails.Dialog"),
      title: "Purchase Order Details",
      cancelButton: true,
      closeButton: true,
      height: 800,
      fullWidth: true,
    },
  ],
  beforeEnter: async ({ rootStore, params }) => {
    const projectDetailsStore =
      rootStore.projectDetailsStore as ProjectDetailsStore;
    const projectId =
      params.projectId && typeof params.projectId === "string"
        ? parseInt(params.projectId, 10)
        : null;

    if (projectId) {
      await projectDetailsStore.loadProject(projectId);
    }

    // Load purchase order line items for the dialog
    const purchaseOrderLineItemsStore = rootStore.purchaseOrderLineItemsStore as ServiceStore;
    if (purchaseOrderLineItemsStore) {
      try {
        await purchaseOrderLineItemsStore.find({
          query: { $limit: 200 }
        });
      } catch (error) {
        console.error("Failed to load purchase order line items:", error);
      }
    }

    return true;
  },
  onParamsChange: async ({ rootStore, params }) => {
    const projectDetailsStore =
      rootStore.projectDetailsStore as ProjectDetailsStore;
    const projectId =
      params.projectId && typeof params.projectId === "string"
        ? parseInt(params.projectId, 10)
        : null;

    if (projectId) {
      await projectDetailsStore.loadProject(projectId);
    }
  },
};

export default projectDetailsRoute;
